import { FC, useState } from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  TooltipProps,
  XAxis,
  YAxis,
} from 'recharts';

import { Currency } from '../../../../../types/currency.types';
import { activeColors, fillColors, strokeColors } from '../../../../cap-table/graphs/index';
import { CustomToolTip, CustomXAxisTick, GraphDataItem } from './liquidity-graph-wrapper';

export const LiquidityGraphDesktop: FC<{
  currency?: Currency | undefined;
  data: GraphDataItem[];
  stakeholderId: string;
}> = ({ data, stakeholderId, currency }) => {
  const [activeIndex, setActiveIndex] = useState<null | number>(null);
  const handleMouseEnter = (index: number) => {
    setActiveIndex(index);
  };

  const handleMouseLeave = () => {
    setActiveIndex(null);
  };

  return (
    <ResponsiveContainer height={510} width="100%">
      <BarChart data={data} height={40} width={150}>
        <XAxis
          axisLine={{ stroke: '#F2F4F7', strokeWidth: 1 }}
          dataKey="label"
          interval={0}
          tick={(props) => <CustomXAxisTick {...props} currentStakeholderId={stakeholderId} />}
          tickLine={false}
        />
        <YAxis
          axisLine={false}
          orientation="left"
          stroke="#475467"
          tick={{ fontSize: 10, fontWeight: 500 }}
          tickFormatter={(value) => `${value.toLocaleString('en-US')}`}
          tickLine={false}
          tickMargin={8}
        />
        <CartesianGrid horizontal={true} stroke="#F2F4F7" strokeDasharray="0" vertical={false} />
        <Tooltip
          content={(props) => (
            <CustomToolTip {...(props as TooltipProps<number, string>)} currency={currency} />
          )}
          cursor={false}
        />
        <Bar dataKey="liquidity" radius={[4, 4, 0, 0]}>
          {data.map((entry, index) => (
            <Cell
              fill={
                activeIndex === index
                  ? activeColors[index % activeColors.length]
                  : fillColors[index % fillColors.length]
              }
              fillOpacity={1}
              key={entry.label}
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={handleMouseLeave}
              stroke={strokeColors[index % strokeColors.length]}
              style={{
                transition: 'all 0.5s ease, stroke 0.5s ease',
              }}
            />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};
